import {FC} from 'react'
import {Navigate} from 'react-router-dom'
import {PageTitle} from '../../../_metronic/layout/core'
import {useAuth} from '../../modules/auth'
import {AdminDashboardPanel} from './components/AdminDashboardPanel'
import useSize from '../../hooks/useSize'
import {DEFAULT_HOME_PATH} from '../../utils/homePath'

import styles from './adminDashboard.module.css'

const AdminDashboardPage: FC = () => {
  const user = useAuth()

  if (user.currentUser?.role?.slug !== 'ADMIN') {
    return <Navigate to={DEFAULT_HOME_PATH} replace />
  }

  return (
    <div className={styles.divGlobal}>
      <AdminDashboardPanel
        userAny={
          user.currentUser
            ? {
                email: user.currentUser.email ? user.currentUser.email : '',
                name: user.currentUser.name ? user.currentUser.name : '',
                role: user.currentUser.role.slug ? user.currentUser.role.slug : '',
              }
            : null
        }
      />
    </div>
  )
}

const AdminDashboardWrapper: FC = () => {
  const {width} = useSize()

  return (
    <div>
      <div className={styles.divGlobalPrincipal}>
        {width > 1200 && (
          <PageTitle breadcrumbs={[]}>
            Painel de Controle
          </PageTitle>
        )}
      </div>
      <AdminDashboardPage />
    </div>
  )
}

export {AdminDashboardWrapper}
